import { logEvent } from './logGaEvent'

// MD Carousel Left/Right Arrow Click
const logCarouselArrow = () => {
  logEvent('internal_link', {
    link_name: 'multidestination',
    link_item: 'arrow',
    product_name: 'air',
    page_name: 'listings',
  })
}

// MD Change Flight Button Click
const logChangeFlight = tripType => {
  if (tripType === 'MD') {
    logEvent('internal_link', {
      link_name: 'multidestination',
      link_item: 'change_flight',
      product_name: 'air',
      page_name: 'listings',
    })
  }
}

export { logCarouselArrow, logChangeFlight }
